var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data"},[_c('span',{staticClass:"number",style:({color: _vm.color})},[_vm._v(_vm._s(_vm.total))]),_c('div',{staticClass:"label"},[_vm._v(" "+_vm._s(_vm.label)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }